import domReady from '@wordpress/dom-ready';

domReady(() => {
  // const stickyLimit = 200;
  const stickyLimit = 10;

  function stickyNavbar() {
    const st = window.scrollY;
    if (st >= stickyLimit) {
      document.body.classList.add('js-did-scroll');
    } else {
      document.body.classList.remove('js-did-scroll');
    }
  }

  window.addEventListener('scroll', stickyNavbar);

  stickyNavbar();
});
